class StSecureCommSession {
    private static instance: StSecureCommSession;
    public CLIENT_PUBLIC_KEY_TAG: string = "clientPublicKey";
    public CLIENT_PRIVATE_KEY_TAG: string = "clientPrivateKey";
    public EK_SC_SESSION_KEY: string = "X-EK-SC-SESSION-ID";
    public SYMMETRIC_KEY_TAG: string = "symmetricKey";

    public clientPublicKey: string | null = null;
    public clientPrivateKey: string | null = null;
    public symmetricKey: string | null = null;

    private constructor() {
    }

    public static getInstance(): StSecureCommSession {
        if (!StSecureCommSession.instance) {
            StSecureCommSession.instance = new StSecureCommSession();
        }
        return StSecureCommSession.instance;
    }

    public saveClientPublicKey(value: string): void {
        window.sessionStorage.setItem(this.CLIENT_PUBLIC_KEY_TAG, value);
    }

    public setStSessionKey(value: string): string | null {
        window.sessionStorage.setItem(this.EK_SC_SESSION_KEY, value);
        return window.sessionStorage.getItem(this.EK_SC_SESSION_KEY);
    }

    public saveClientPrivateKey(value: string): void {
        window.sessionStorage.setItem(this.CLIENT_PRIVATE_KEY_TAG, value);
    }

    public setSymmetricKey(value: string): void {
        window.sessionStorage.setItem(this.SYMMETRIC_KEY_TAG, value);
    }

    public getSymmetricKey(): string | null {
        return window.sessionStorage.getItem(this.SYMMETRIC_KEY_TAG);
    }
}

export default StSecureCommSession;
